import React from "react";
import "../styles/pages.css";

function AboutUs() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-title fade-in">About PICKTECH</h1>
          <p className="about-subtitle slide-up">
            Innovative Digital Solutions for Modern Businesses
          </p>
        </div>
      </div>

      <div className="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-content fade-in">
              <h2 className="section-title-left">Our Story</h2>
              <div className="title-underline-left"></div>
              <p>
                Founded in February 2025, PICKTECH is a technology startup
                established by Jacob Yu, a Computer Science graduate from the
                University of Wollongong, Australia. After gaining valuable
                industry experience as a developer at an Australian tech
                company, Jacob established PICKTECH to create innovative digital
                solutions that address real business challenges.
              </p>
              <p>
                We're a lean, agile company that specializes in web development,
                mobile applications, and digital business solutions. Our
                technical expertise and dedication to quality allow us to
                deliver enterprise-grade solutions with the personalized touch
                and flexibility of a boutique studio.
              </p>
            </div>
            <div className="about-image-container slide-up">
              <img
                src="/images/jacob.jpg"
                alt="Jacob Yu - PICKTECH Founder"
                className="about-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
